import api from './api';

export interface Course {
  id?: string;
  schoolId?: string;
  name: string;
  description?: string;
  levelId: string;
  teacherId?: string;
  classIds?: string[];
  enabled?: boolean;
  factor?: number; // Weight for bulletin calculation
  creationDatetime?: string;
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface CourseSearchFilters {
  name?: string;
  levelId?: string;
  teacherId?: string;
  enabled?: boolean;
}

export interface CourseSearchRequest {
  page?: number;
  size?: number;
  filters?: CourseSearchFilters;
}

export const courseService = {
  getAllCourses: async (): Promise<Course[]> => {
    const response = await api.get<Course[]>('/{schoolId}/courses');
    return response.data;
  },

  searchCourses: async (request: CourseSearchRequest = {}): Promise<PageResponse<Course>> => {
    const searchRequest = {
      page: request.page ?? 0,
      size: request.size ?? 100,
      filters: request.filters || {},
    };

    const response = await api.post<PageResponse<Course>>('/{schoolId}/courses/search', searchRequest);
    return response.data;
  },

  getCourseById: async (id: string): Promise<Course> => {
    const response = await api.get<Course>(`/{schoolId}/courses/${id}`);
    return response.data;
  },

  createCourse: async (course: Course): Promise<Course> => {
    const response = await api.post<Course>('/{schoolId}/courses', course);
    return response.data;
  },

  updateCourse: async (id: string, course: Course): Promise<Course> => {
    const response = await api.put<Course>(`/{schoolId}/courses/${id}`, course);
    return response.data;
  },

  deleteCourse: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/courses/${id}`);
  },
};

